import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import type { RefinementScorePoint } from '../../api/types';

interface Props {
  history: RefinementScorePoint[];
}

export default function ScoreSparkline({ history }: Props) {
  if (!history.length) {
    return (
      <div className="card text-sm text-gray-500">
        No score history yet — recompute to populate.
      </div>
    );
  }

  const data = history.map((p) => ({
    attempt: p.attempt,
    score: Number(p.score.toFixed(3)),
  }));

  return (
    <div className="card">
      <div className="text-xs uppercase text-gray-500 mb-2">Score history</div>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis
              dataKey="attempt"
              label={{ value: 'attempt', position: 'insideBottom', offset: -2, fontSize: 11 }}
              tick={{ fontSize: 11 }}
            />
            <YAxis domain={[0, 1]} tick={{ fontSize: 11 }} />
            <Tooltip />
            <ReferenceLine y={0.4} stroke="#ef4444" strokeDasharray="2 2" label={{ value: 'fail', fontSize: 10, fill: '#ef4444' }} />
            <ReferenceLine y={0.7} stroke="#10b981" strokeDasharray="2 2" label={{ value: 'consent', fontSize: 10, fill: '#10b981' }} />
            <Line type="monotone" dataKey="score" stroke="#0284c7" strokeWidth={2} dot={{ r: 4 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
